var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { get, set, action } from '@ember/object';
import { compareAsc, getDay } from 'date-fns';
import { getReadableScheduleEligibilityOffset } from 'garaje/utils/getReadableScheduleEligibilityOffset';
let ScheduleIndexController = (_class = class ScheduleIndexController extends Controller {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "state", _descriptor, this);
    _initializerDefineProperty(this, "registrations", _descriptor2, this);
    _initializerDefineProperty(this, "localStorage", _descriptor3, this);
    _initializerDefineProperty(this, "featureConfig", _descriptor4, this);
    _initializerDefineProperty(this, "abilities", _descriptor5, this);
    _defineProperty(this, "queryParams", ['selectedInviteId']);
    _initializerDefineProperty(this, "selectedInviteId", _descriptor6, this);
  }
  get days() {
    return this.registrations.days.sort((a, b) => compareAsc(a.date, b.date));
  }
  get isPartialDayEnabled() {
    return this.abilities.can('use partial day booking desk');
  }
  get showRequiredDocumentExpiredBanner() {
    const noRequiredDocumentApproval = this.days.find(day => !day.hasRequiredDocumentApproval);
    return noRequiredDocumentApproval;
  }
  get hasDesks() {
    return this.state.currentLocationEnabledDesks?.desksQuantity > 0;
  }
  get desksEnabled() {
    const {
      currentLocationEnabledDesks,
      desksSubscription
    } = this.state;
    return desksSubscription && !desksSubscription.onExpiredTrial && currentLocationEnabledDesks && currentLocationEnabledDesks.active;
  }
  get bookDeskEnabled() {
    return this.desksEnabled && this.screeningFlowEnabled && this.hasDesks && this.featureConfig.isEnabled('deskReservations.booking');
  }
  get screeningFlowEnabled() {
    return this.state.currentLocation.employeeScreeningEnabled;
  }
  get selectedDay() {
    // must check selectedInviteId because some screeningCards have an id of null in production
    if (!this.selectedInviteId) {
      return null;
    }

    // The day doesn't have an ID, so have to select on a related object's id
    return this.days.find(day => day.screeningCard.id == this.selectedInviteId);
  }
  get indexedDays() {
    return this.days.map((day, index) => {
      return {
        ...day,
        index
      };
    });
  }
  get weeks() {
    const days = get(this, 'indexedDays');
    if (days.length == 0) return [];
    let i = 0;
    const daysLeftAtStart = 7 - getDay(days[0].date);
    const weeks = [days.slice(0, daysLeftAtStart)];
    i += daysLeftAtStart;
    while (i < days.length) {
      weeks.push(days.slice(i, i + 7));
      i += 7;
    }
    return weeks;
  }
  get shouldLoadDays() {
    const {
      scheduleEligibilityOffset
    } = this.state.currentLocation;
    if (scheduleEligibilityOffset == null) {
      return true;
    }
    return this.daysToLoad > 0;
  }
  get daysToLoad() {
    const {
      scheduleEligibilityOffset
    } = this.state.currentLocation;
    if (scheduleEligibilityOffset == null) {
      return 180;
    }
    const offsetInDays = -scheduleEligibilityOffset / 1440 - this.days.length;
    return Math.min(offsetInDays, 90);
  }
  get readableScheduleEligibilityOffset() {
    return getReadableScheduleEligibilityOffset(this.state.currentLocation.scheduleEligibilityOffset);
  }
  get isScheduleEligibilityOffsetNotificationVisible() {
    const {
      scheduleEligibilityOffset
    } = this.state.currentLocation;
    const offset = this.storedScheduleEligibilityOffset;
    return offset !== scheduleEligibilityOffset && scheduleEligibilityOffset !== null;
  }
  get storedScheduleEligibilityOffset() {
    const {
      id
    } = this.state.currentLocation;
    try {
      let offsets = get(this.localStorage, 'schedule_eligibility_offsets');
      offsets = offsets ? JSON.parse(offsets) : [];
      const {
        offset
      } = offsets.find(l => l.locationId === id) || {};
      return offset;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
    return undefined;
  }
  get showDbeamEaBanner() {
    return this.abilities.can('visit dbeam');
  }
  removeStoredScheduleEligibilityOffset() {
    const {
      id
    } = this.state.currentLocation;
    try {
      let offsets = get(this.localStorage, 'schedule_eligibility_offsets');
      offsets = offsets ? JSON.parse(offsets) : [];
      const index = offsets.findIndex(l => l.locationId === id);
      if (index > -1) {
        offsets.splice(index, 1);
      }
      set(this.localStorage, 'schedule_eligibility_offsets', JSON.stringify(offsets));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
  closeScheduleEligibilityOffsetNotification() {
    const {
      id,
      scheduleEligibilityOffset
    } = this.state.currentLocation;
    const locationItem = {
      locationId: id,
      offset: scheduleEligibilityOffset
    };
    try {
      let offsets = get(this.localStorage, 'schedule_eligibility_offsets');
      offsets = offsets ? JSON.parse(offsets) : [];
      const index = offsets.findIndex(l => l.locationId === id);
      if (index > -1) {
        offsets.splice(index, 1, locationItem);
      } else {
        offsets.pushObject({
          locationId: id,
          offset: scheduleEligibilityOffset
        });
      }
      set(this.localStorage, 'schedule_eligibility_offsets', JSON.stringify(offsets));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "registrations", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "localStorage", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "featureConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "abilities", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedInviteId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "closeScheduleEligibilityOffsetNotification", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeScheduleEligibilityOffsetNotification"), _class.prototype)), _class);
export { ScheduleIndexController as default };